import { combineReducers, configureStore, PreloadedState } from '@reduxjs/toolkit';
// This is how you import a reducer, based on the prior export.
import productReducer from './slices/productSlice';
import cartReducer from './slices/cartSlice';
import loginReducer from './slices/loginSlice';

// Create the root reducer independently to obtain the RootState type
const rootReducer = combineReducers({
  // You are free to call the LHS what you like, but it must have a reducer on the RHS.
  product: productReducer,
  cart: cartReducer,
  login: loginReducer,
});

const setupStore = function (preloadedState?: PreloadedState<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export default setupStore;

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
